import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import type { SliceUserSegmentsSettings } from './slice-user-segments-settings.model';


export const SliceUserSegmentsDefinition: IdtComponentDefinition = {
  id: 'slice-user-segments',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceUserSegmentsCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Segmento de usuario',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web'],
  initialSettings: (): SliceUserSegmentsSettings => ({
    general: {
      numSlots: 1,
      userSegments: [],
      excludedUserSegments: [],
      compositionId: ''
    },
    slots: [
      { ...initialSliceSlotState }
    ],
    styles: {
      ...SliceStylesDefaultValues
    }
  })
};

